module.exports = __webpack_public_path__ + "static/media/melanie&danielw-40_websize.504a4bc1.jpg";